<template>
  <nav class="menu-container">
    <h3><font color="#F8779E">10号线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          name: "futiankouan",
          title: "福田口岸",
          // icon: "chat",
          exact: true,
        },
        {
          name: "fumin",
          title: "福民",
          // icon: "chat",
          exact: true,
        },
        {
          name: "gangxia",
          title: "岗厦",
          // icon: "chat",
          exact: true,
        },
        {
          // 此站点为岗厦北，是gangxiabei2,是10号线和11号线交叉。
          name: "gangxiabei2",
          title: "岗厦北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "lianhuacun",
          title: "莲花村",
          // icon: "chat",
          exact: true,
        },
        {
          name: "donggualing",
          title: "冬瓜岭",
          // icon: "chat",
          exact: true,
        },
        {
          name: "maling",
          title: "孖岭",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yabao",
          title: "雅宝",
          // icon: "chat",
          exact: true,
        },
        {
          name: "nankeng",
          title: "南坑",
          // icon: "chat",
          exact: true,
        },
        {
          name: "guangyayuan",
          title: "光雅园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "wuhe",
          title: "五和",
          // icon: "chat",
          exact: true,
        },
        {
          name: "bantianbei",
          title: "坂田北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "beierlu",
          title: "贝尔路",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huawei",
          title: "华为",
          // icon: "chat",
          exact: true,
        },
        {
          name: "gangtou",
          title: "岗头",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xuexiang",
          title: "雪象",
          // icon: "chat",
          exact: true,
        },
        {
          name: "gankeng",
          title: "甘坑",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liangmaoshan",
          title: "凉帽山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shanglilang",
          title: "上李朗",
          // icon: "chat",
          exact: true,
        },
        {
          name: "mugu",
          title: "木古",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huanancheng",
          title: "华南城",
          // icon: "chat",
          exact: true,
        },
        {
          name: "hehua",
          title: "禾花",
          // icon: "chat",
          exact: true,
        },
        {
          name: "pinghu",
          title: "平湖",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shuangyongjie",
          title: "双拥街",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>





<!-- <template>
  <div>
    <h3>
        首页<br><br>
深圳地铁1号线 途经站点 共30站<br><br>
注：高峰期发车间隔为4分钟，平峰期为6分钟<br><br>

罗湖站-国贸站-老街站-大剧院站-科学馆站-华强路站-岗厦站-会展中心站-购物公园站-香蜜湖站-车公庙站-竹子林站-侨城东站-华侨城站-世界之窗站-白石洲站-高新园站-深大站-桃园站-大新站-鲤鱼门站-前海湾站-新安站-宝安中心站- 宝体站-坪洲站-西乡站-固戍站-后瑞站-机场东站
    </h3>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style> -->